if (!customElements.get('dd0-collapsible-group')) {
class DD0CollapsibleGroup extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.singleOpen = this.dataset.singleOpen === 'true';
    this.rows = Array.from(this.querySelectorAll('details.dd0-cc__row'));

    if (this.singleOpen) {
      let firstOpen = null;
      this.rows.forEach((row) => {
        if (row.open) {
          if (firstOpen === null) firstOpen = row;
          else row.open = false;
        }
      });
    }

    this.rows.forEach((row) => {
      const summary = row.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', (e) => this.onSummaryClick(e, row), { signal: this.controller.signal });
    });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }

  onSummaryClick(e, row) {
    if (!this.singleOpen) return;
    if (row.open) return;
    this.rows.forEach((other) => {
      if (other !== row && other.open) other.open = false;
    });
  }
}

customElements.define('dd0-collapsible-group', DD0CollapsibleGroup);
}
